import { checkOnScreenEls } from '../../../../assets/src/js/common/on-screen';
import '../sass/insights-listing.scss';

(() => {
    const $blocks = document.querySelectorAll('[data-insights-listing]');

    if (!$blocks.length) return;

    $blocks.forEach($block => {
        const $form = $block.querySelector('.js-insights-listing-form');
        const $pageInput = $block.querySelector('.js-insights-listing-page');
        const $results = $block.querySelector('.js-insights-listing-results');
        const $pagination = $block.querySelector('.js-insights-listing-pagination');
        const ajaxUrl = $block.dataset.ajaxUrl;
        let searchTimeout;

        if (!$form || !$pageInput || !$results || !$pagination || !ajaxUrl) return;

        const $search = $form.querySelector('[name="search"]');
        const $categoryInput = $form.querySelector('.js-insights-listing-category');
        const $pills = $form.querySelectorAll('.insights-listing__pill');

        const fetchResults = () => {
            const formData = new FormData($form);

            $block.classList.add('insights-listing--loading');

            fetch(ajaxUrl, {
                method: 'POST',
                body: formData
            }).then(async response => {
                if (!response.ok) {
                    throw new Error(`Response status: ${response.status}`);
                }

                return response.json();
            }).then(json => {
                if (!json.success) return;

                $results.innerHTML = json.data.results;
                $pagination.innerHTML = json.data.pagination;
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                $block.classList.remove('insights-listing--loading');

                checkOnScreenEls();
            });
        };

        const resetPageAndFetch = () => {
            $pageInput.value = 1;
            fetchResults();
        };

        $form.addEventListener('submit', e => {
            e.preventDefault();
            resetPageAndFetch();
        });

        $pills.forEach($pill => {
            $pill.addEventListener('click', () => {
                $pills.forEach($item => {
                    $item.setAttribute('aria-pressed', $item === $pill ? 'true' : 'false');
                });

                if ($categoryInput) {
                    $categoryInput.value = $pill.dataset.category || '';
                }

                resetPageAndFetch();
            });
        });

        if ($search) {
            const debouncedSearch = () => {
                clearTimeout(searchTimeout);

                searchTimeout = setTimeout(resetPageAndFetch, 400);
            };

            $search.addEventListener('input', debouncedSearch);
            $search.addEventListener('search', debouncedSearch);
        }

        $pagination.addEventListener('click', e => {
            const $button = e.target.closest('[data-page]');

            if (!$button || $button.disabled) return;

            $pageInput.value = $button.dataset.page;
            fetchResults();
        });
    });
})();
